module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('router-link', {
    staticClass: "login background-1-100",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact us")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            It looks like you don’t have permission to access this page\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description text-left"
  }, [_vm._v("\n          Unfortunately, your membership level doesn’t allow you to access this page."), _c('br'), _vm._v("\n          If you’d like to find out more about how this works and how you can be granted access to this page and others, please get in touch with us.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f144563","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/NoPermissions.vue
// module id = 1019
// module chunks = 0